import AgeDistributionDark from './dark/ageDistribution_dark.svg';
import AttendanceByGenderDark from './dark/attendanceByGender_dark.svg';
import AverageAgeDynamicsDark from './dark/averageAgeDynamics_dark.svg';
import EmotionDistributionDark from './dark/emotionDistribution_dark.svg';
import GenderDistributionDark from './dark/genderDistribution_dark.svg';
import GenderRatioDark from './dark/genderRatio_dark.svg';
import AgeDistributionLight from './light/ageDistribution.svg';
import AttendanceByGenderLight from './light/attendanceByGender.svg';
import AverageAgeDynamicsLight from './light/averageAgeDynamics.svg';
import EmotionDistributionLight from './light/emotionDistribution.svg';
import GenderDistributionLight from './light/genderDistribution.svg';
import GenderRatioLight from './light/genderRatio.svg';

export const getDiagrams = (isLightTheme) => ({
  AgeDistribution: isLightTheme ? AgeDistributionLight : AgeDistributionDark,
  AttendanceByGender: isLightTheme ? AttendanceByGenderLight : AttendanceByGenderDark,
  AverageAgeDynamics: isLightTheme ? AverageAgeDynamicsLight : AverageAgeDynamicsDark,
  EmotionDistribution: isLightTheme ? EmotionDistributionLight : EmotionDistributionDark,
  GenderDistribution: isLightTheme ? GenderDistributionLight : GenderDistributionDark,
  GenderRatio: isLightTheme ? GenderRatioLight : GenderRatioDark,
});
